module.exports = __webpack_public_path__ + "img/analytics_c44d5bd.webp";